import BillService from '@/services/BillService';
import router from '@/router';
import dayjs from 'dayjs';
import Vue from 'vue';
import { TOGGLE_BILL_MODAL_VISIBLE } from '../mutation-types';
import { constant } from '@/utils/helper';
const { PROMOTION } = constant;
const { COMMISSION_ITEM } = constant;
const { AMOUNT_PAYTYPE, TOTAL_PAYTYPE } = constant;
// state
const localState = {
  autoLoad: {
    loading: false,
    loader: BillService.getAll,
    emptyMap: {},
  },
  payTypes: {},
  bills: {},
  shifts: {},
  bill: {
    id: '',
    table: '',
    room: '',
    cover: '',
    customer: '',
    staff: '',
    billItems: [],
    payDetails: [],
  },
  emptyBill: {
    id: '',
    table: '',
    room: '',
    cover: '',
    customer: '',
    staff: '',
    billItems: [],
    payDetails: [],
  },
  selectedItem: { empty: true },
  previousOrder: [],
  currentInputField: '',
  currentQuantityIncrease: 1,
  billModal: '',
  payCash: '',
  secondBill: { empty: true },
  firstBill: { empty: true },
  NORMAL_ITEM: 0,
  MIXER_ITEM: 1,
  COMMISSION_ITEM: 2,
  TIMER_ITEM: 5,
  OPEN_STATUS: 0,
  CLOSED_STATUS: 1,
  VOIDED_STATUS: 2,
  lastPing: null,
  ajaxCounter: 0,
  nextPingIn: 10,
};
// getters
const localGetters = {
  getItemList: state => (filters, mode = 'new') => {
    const list = mode == 'new' ? state.bill.billItems : state.previousOrder;
    return list.filter((item) => {
      let matched = true;
      if (filters) {
        filters.forEach((filter) => {
          if (item[filter.property] != filter.value) matched = false;
        });
      }
      return matched;
    });
  },

  getNormalItems: (state, getters) => {
    if (!state.bill.billItems.length) return null;
    return getters.getItemList([
      {
        property: 'type', value: state.NORMAL_ITEM,
      },
    ]);
  },

  getFirstNormalItem: (state, getters) => {
    const normalItems = getters.getNormalItems;
    if (!normalItems) return null;
    return normalItems[0];
  },

  getLastNormalItem: (state, getters) => {
    const normalItems = getters.getNormalItems;
    if (!normalItems) return null;
    return normalItems[normalItems.length - 1];
  },

  isBill: state => (status) => {
    switch (status) {
      case 'open': return state.bill.status == state.OPEN_STATUS;
      case 'closed': return state.bill.status == state.CLOSED_STATUS;
      case 'voided': return state.bill.status == state.VOIDED_STATUS;
    }
  },
  checkDecimal: (state, getters, rootState) => (currentAmount) => {
    let amount = 0;
    if (rootState.auth.currency && rootState.auth.currency.decimalType) {
      amount = parseFloat(currentAmount).toFixed(2);
    } else {
      amount = Math.ceil(parseFloat(currentAmount));
    }
    return amount;
  },
  totalAmount: (state, getters) => {
    const location = getters.getMap('user', true).location;
    let currentAmount = 0;

    state.previousOrder.forEach((item) => {
      currentAmount += item.total;
    });

    state.bill.billItems.forEach((item) => {
      currentAmount += item.total;
    });

    let currentOperator = -1;
    let lastCalculateAmount = currentAmount;
    let totalAmount = 0;
    const payTypes = getters
      .getArray('payTypes')
      .sort((a, b) => (a.indexNumber > b.indexNumber ? 1 : -1));
    payTypes.forEach((payType) => {
      const payDetail = getters.getPayDetail(payType);
      if(!payDetail) return
      switch (payType.name) {
        case 'subtotal':
          payDetail.total = currentAmount;
          currentOperator = -1;
          break;
        case 'total':
          payDetail.total = currentAmount;
          lastCalculateAmount = currentAmount;
          currentOperator = 1;
          break;
        case 'amount':
          payDetail.total = getters.checkDecimal(currentAmount);
          lastCalculateAmount = currentAmount;
          currentOperator = -1;
          totalAmount = payDetail.total;
          break;
        case 'change':
          payDetail.total = -1 * getters.checkDecimal(currentAmount);
          break;
        default:
          if (payType.value && payType.value != 0) {
            if(location.useArticleVat) {
              // leave as is
            } else {
              if (payType.includeOnPrice) {
                payDetail.total = lastCalculateAmount * payType.value / (100 + payType.value);
              } else {
                payDetail.total = lastCalculateAmount * payType.value / 100;
              }
            }

          } else if (!payDetail.total) {
            payDetail.total = 0;
          }
          if (!payType.includeOnPrice) {
            currentAmount += currentOperator * payDetail.total;
          }
      }
    });
    return totalAmount;
  },

  totalChange: (state, getters) => parseFloat(state.payCash).toFixed(2) - parseFloat(getters.totalAmount).toFixed(2),

  getCommissionOfItem: (state, getters) => (parent, mode = 'new', list = null) => {
    let marker = false;
    let commission = null;
    let tmpList = null;
    if (!list) tmpList = getters.getItemList(null, mode);
    else tmpList = Object.assign([], list);
    tmpList.forEach((item) => {
      if (marker && item.type == state.NORMAL_ITEM) {
        marker = false;
      }
      if (marker && item.type == state.COMMISSION_ITEM) {
        commission = item;
      }
      if (item == parent) {
        marker = true;
      }
    });
    return commission;
  },

  getLastItemMixers: (state, getters) => {
    const lastItem = getters.getLastNormalItem;
    if (!lastItem || lastItem.qty < 0) return false;
    let article = getters.getObject(lastItem.product, 'articles');
    if(!article) return false;
    const clone = getters.getArticleClone(article);
    if (clone) {
      article = clone;
    }
    const mixers = getters.getArticleMixers(article);
    return mixers.length == 0 ? false : mixers;
  },

  getSelectedItemCookingOptions: (state, getters) => {
    const { selectedItem } = state;
    if (!selectedItem || selectedItem.qty < 0) return false;
    const article = getters.getObject(selectedItem.product, 'articles');
    if (!article) return false;
    const clone = getters.getArticleClone(article);
    let { cookingOptions } = clone || article;
    if (typeof cookingOptions === 'string') {
      cookingOptions = JSON.parse(cookingOptions);
    }
    return !cookingOptions || cookingOptions.length === 0 ? false : cookingOptions;
  },

  getMixersOfItem: (state, getters) => (parent, list = null) => {
    let marker = false;
    const mixers = [];
    if (!list) list = getters.getItemList();
    list.forEach((item) => {
      if (marker && item.type == state.NORMAL_ITEM) {
        marker = false;
      }
      if (marker && item.type == state.MIXER_ITEM) {
        mixers.push(item);
      }
      if (item == parent) {
        marker = true;
      }
    });
    return mixers;
  },

  articleBillQuantity: state => (item) => {
    const articleId = item.product;
    const itemPromotion = item.promotion;
    let qtyTotal = 0;
    state.previousOrder.forEach(({
      qty, product, type, promotion,
    }) => {
      if (product === articleId && type != state.COMMISSION_ITEM && (!!promotion === !!itemPromotion)) {
        qtyTotal += qty;
      }
    });
    state.bill.billItems.forEach(({
      qty, product, type, promotion,
    }) => {
      if (product === articleId && type != state.COMMISSION_ITEM && (!!promotion === !!itemPromotion)) {
        qtyTotal += qty;
      }
    });
    return qtyTotal;
  },

  getPayDetail: (state, getters) => (payType) => {
    if(!state.bill.payDetails) return [];
    const payDetails = state.bill.payDetails.filter(pD => pD.payType == payType.id);
    let payDetail = payDetails.length > 0 ? payDetails[payDetails.length - 1] : null;
    if (payDetail) return payDetail;
    const location = getters.getMap('user', true).location;
    // if is vat / charge and is not set in API, will return null
    if(!payDetail && location.useArticleVat) {
      const itIsCharge = getters
                      .getArray('payTypes')
                      .find(pT => pT.indexNumber > TOTAL_PAYTYPE
                                      && pT.indexNumber < AMOUNT_PAYTYPE
                                      && pT.id === payType.id
                            )
      if(itIsCharge) return null
    }
    payDetail = {
      payType: payType.id,
      total: 0,
    };
    state.bill.payDetails.push(payDetail);
    return payDetail;
  },

  previousOrderSeparators: ({ previousOrder }) => {
    if (!previousOrder.length) {
      return [0];
    }

    const indexs = [0];
    let currentCreatedDate = previousOrder[0].createdDate;
    previousOrder.forEach((item, index) => {
      const itemDate = dayjs(item.createdDate);
      const currentDate = dayjs(currentCreatedDate);
      if ((currentDate.unix() - itemDate.unix()) < -3) {
        currentCreatedDate = item.createdDate;
        indexs.push(index);
      }
    });

    return indexs;
  },

  getItemParent: state => parent => state.previousOrder.find(item => item.id == parent),

  isPayInvoice: (state, getters) => {
    if (!state.bill.customer) return false;
    const customer = getters.getObject(state.bill.customer, 'customers');
    if (!customer || !customer.customerType) return false;
    const customerType = getters.getObject(customer.customerType, 'customerTypes');
    if (!customerType || !customerType.payInvoice) return false;
    return true;
  },

  /* action getters */

  pickArticle: (state, getters) => (article) => {
    if (state.bill.staff
        && (state.bill.table
            || state.bill.room)) {
      const clone = getters.getArticleClone(article);
      if (article.variablePrice
        ||
        (clone && clone.variablePrice)
      ) {
        router.push({ name: 'variable-price', params: { article } });
      } else {
        getters.addArticle(article);
      }
      return true;
    }
    return false;
  },

  addArticle: (state, getters) => (
    article,
    creditBackMode = false,
    promotionItem = null,
    currentPrice = null,
    creditBackQty = null,
    creditBackTotal = null,
  ) => {
    if (creditBackMode) {
      state.currentQuantityIncrease = -1;
    }

    state.currentQuantityIncrease = state.currentQuantityIncrease !== 0 ? state.currentQuantityIncrease : 1;

    const lastItem = getters.getLastNormalItem;

    /* Not allow to order when in credit back mode */
    const isCreditBackMode = state.bill.billItems.find(({ qty }) => qty < 0) !== undefined;
    if (state.currentQuantityIncrease > 0 && isCreditBackMode) {
      return;
    }

    const clone = getters.getArticleClone(article);
    const originalPrice = clone && !clone.variablePrice ? clone.price : article.price;
    const orderLevel = clone ? clone.orderLevel : article.orderLevel;
    const cost = clone && clone.cost ? clone.cost : article.cost;
    const promotion = creditBackMode ? null : getters.getPromotionByArticle(article);
    const isBuyXGetYItem = getters.isBuyXGetYPromotion(promotion);
    const actualPrice = currentPrice || (
      promotionItem
        ? promotionItem.price
        : getters.getPromotionPrice(promotion, originalPrice)
    );
    const shownPromotionName = (promotion
                                  && promotion.promotionType !== PROMOTION.BUY_X_GET_Y
                                )
                                ? promotion.name
                                : '';

    const newItem = {
      product: article.id,
      staff: state.bill.staff,
      orderLevel,
      price: actualPrice,
      qty: state.currentQuantityIncrease,
      total: state.currentQuantityIncrease * actualPrice,
      buyPrice: cost ? cost.toFixed(2) : 0,
      note: '',
      type: state.NORMAL_ITEM,
      promotion: creditBackMode ? null : shownPromotionName,
      productPrice: originalPrice,
    };
    if (getters.isTimerArticle(article.id)) {
      if(creditBackMode) {
        newItem.total = 0 - creditBackTotal;
        newItem.qty = 0 - creditBackQty;
      } else {
        newItem.timeStart = getters.getDatetime();
        newItem.timeEnd = null;
        newItem.total = 0;
      }
    }
    if (promotionItem !== null) {
      newItem.promotion = promotionItem.promotion;
      newItem.total = promotionItem.total / promotionItem.qty * state.currentQuantityIncrease;
    }

    let isBought = true;
    let currentBuy = 0;
    let currentGet = 0;
    let remainGet = 0;

    const buyXGetYItems = getters.getBuyXGetYItems(true);
    const included = buyXGetYItems[article.id];

    if (included) {
      const { promotionBuyX, promotionGetY, totalQty } = included;
      const block = promotionBuyX + promotionGetY;
      const buyAndGetInBlock = totalQty % block;
      currentBuy = (buyAndGetInBlock > promotionBuyX) ? promotionBuyX : buyAndGetInBlock;
      currentGet = (buyAndGetInBlock > currentBuy) ? (buyAndGetInBlock - currentBuy) : 0;

      remainGet = getters.calRemainGetY(promotion, currentBuy, currentGet);
      if (remainGet > 0) {
        isBought = false;
      }
    }

    if (lastItem
      && lastItem.product === article.id
      && !getters.getMixersOfItem(lastItem).length
      && !getters.getCommissionOfItem(lastItem)
      && !lastItem.isBuyXGetYItem
      && article.type !== state.TIMER_ITEM
      && lastItem.promotion == newItem.promotion
      && (!article.variablePrice || lastItem.price == newItem.price)
    ) {
      // Update quantity and amount
      lastItem.qty += state.currentQuantityIncrease;
      lastItem.total += state.currentQuantityIncrease * actualPrice;
      lastItem.margin = newItem.buyPrice === 0 ? 0 : parseFloat((lastItem.total - (lastItem.buyPrice * lastItem.qty)).toFixed(2));
      currentBuy += state.currentQuantityIncrease;
    } else if (isBought) {
      // Add new item to order
      newItem.margin = newItem.buyPrice === 0 ? 0 : parseFloat((newItem.total - newItem.buyPrice).toFixed(2));
      state.bill.billItems.push(newItem);
      currentBuy += state.currentQuantityIncrease;
    }

    remainGet = getters.calRemainGetY(promotion, currentBuy, currentGet);
    if (remainGet > 0) {
      const getYItem = {
        ...newItem,
        qty: remainGet,
        total: 0,
        margin: newItem.buyPrice === 0 ? 0 : -((newItem.buyPrice) * remainGet),
        promotion: promotion.name,
        isBuyXGetYItem,
      };
      state.bill.billItems.push(getYItem);
    }
    state.currentQuantityIncrease = 1;
  },

  addMixer: (state, getters) => (mixer) => {
    const clone = getters.getArticleClone(mixer);
    const price = clone ? clone.price : mixer.price;
    const cost = clone ? clone.cost : mixer.cost;

    const promotion = getters.getPromotionByArticle(mixer);
    const actualPrice = getters.getPromotionPrice(promotion, price);
    const shownPromotionName = (promotion
                                  && promotion.promotionType !== PROMOTION.BUY_X_GET_Y)
                                ? promotion.name : '';

    const lastItem = getters.getLastNormalItem;
    const lastItemMixers = getters.getMixersOfItem(lastItem);
    const qtyMixer = lastItemMixers.reduce((sum, { qty }) => sum + qty, 1);
    const lastArticle = getters.getObject(lastItem.product, 'articles', 'id');
    const articleClone = getters.getArticleClone(lastArticle);
    const mixerGroupId = getters.getArticleMixerGroup(articleClone || lastArticle);
    let mixerMax = null;
    if (mixerGroupId) {
      const mixerGroup = getters.getObject(mixerGroupId, 'mixerGroups', 'id');
      mixerMax = mixerGroup ? mixerGroup.maximum : null;
    }
    if (mixerMax == null || qtyMixer <= mixerMax) {
      const lastItemLastMixer = lastItemMixers.length > 0 ? lastItemMixers[lastItemMixers.length - 1] : null;
      const lastProductOrderLevel = getters.getObject(lastItem.product, 'articles').orderLevel;
      const orderLevel = clone
        ? (clone.orderLevel
          ? clone.orderLevel
          : lastProductOrderLevel)
        : (mixer.orderLevel
          ? mixer.orderLevel
          : lastProductOrderLevel);
      if (lastItemLastMixer !== null && lastItemLastMixer.product === mixer.id) {
        lastItemLastMixer.qty += state.currentQuantityIncrease;
        lastItemLastMixer.total += state.currentQuantityIncrease * actualPrice;
        lastItemLastMixer.margin = lastItemLastMixer.total - (lastItemLastMixer.qty * lastItemLastMixer.buyPrice);
      } else {
        const newMixer = {
          product: mixer.id,
          staff: state.bill.staff,
          orderLevel,
          parent: lastItem.id,
          price: actualPrice || 0,
          qty: state.currentQuantityIncrease,
          total: state.currentQuantityIncrease * actualPrice,
          type: state.MIXER_ITEM,
          buyPrice: cost ? cost.toFixed(2) : 0,
          promotion: shownPromotionName,
        };
        state.bill.billItems.push({
          ...newMixer,
          margin: newMixer.total - newMixer.buyPrice,
        });
      }
      state.currentQuantityIncrease = 1;
      return true;
    } else {
      return {maximum: mixerMax} ;
    }
  },

  addCommission: (state, getters) => (staff, commission) => {
    let lastItem = getters.getLastNormalItem;
    if(!lastItem) return;
    const promotion = lastItem.promotion
                    ? getters.getArray('promotions').find(promotion => promotion.name == lastItem.promotion)
                    : null;
    let isPromotionInvincible = false;
    if(promotion
      && promotion.promotionType == PROMOTION.FREE_ALL
    ) {
      isPromotionInvincible = true;
    }
    if (lastItem.isBuyXGetYItem) {
      const lastIndex = state.bill.billItems.indexOf(lastItem);
      state.bill.billItems.splice(lastIndex, 1);
      lastItem = getters.getLastNormalItem;
    } else {
      if(!isPromotionInvincible) {
        lastItem.promotion = '';
      }
    }
    const lastItemCommission = getters.getCommissionOfItem(lastItem);
    if (lastItemCommission) {
      const index = state.bill.billItems.indexOf(lastItemCommission);
      state.bill.billItems.splice(index, 1);
    }

    const price = commission.amount
      ? commission.amount
      : (commission.percent * lastItem.price / 100);

    const newCommission = {
      product: lastItem.product,
      staff,
      parent: lastItem.id,
      price,
      qty: (lastItem.qty > 1) ? lastItem.qty : 1,
      total: (commission.includePrice || isPromotionInvincible) ? 0 : lastItem.qty * price,
      type: state.COMMISSION_ITEM,
      margin: 0,
      buyPrice: 0,
      commission: commission.commissionId,
      commissionIncludePrice: commission.includePrice,
      commissionShowBill: commission.showOnBill,
    };

    // modify bill item price if it has commission price
    const article = getters.getObject(lastItem.product, 'articles');
    const clone = getters.getArticleClone(article);
    const commissionPrice = clone ? clone.commissionPrice : article.commissionPrice;

    if (!isPromotionInvincible && commissionPrice) {
      newCommission.total = 0;
      newCommission.commissionIncludePrice = true;
      newCommission.price = commission.amount
        ? commission.amount
        : (commission.percent * commissionPrice / 100);
      lastItem.price = 1 * commissionPrice + 1 * (commission.includePrice ? 0 : newCommission.price);

      const isTimer = getters.isTimerArticle(lastItem.product);
      if (!isTimer) {
        lastItem.total = lastItem.qty * lastItem.price;
        lastItem.margin = lastItem.total - lastItem.buyPrice - 1 * (commission.includePrice ? newCommission.price : 0);
      } else if (lastItem.timeEnd) {
        const total = lastItem.qty * lastItem.price;
        lastItem.total = getters.calTotal(article, total, lastItem.price);
        lastItem.margin = lastItem.total - lastItem.buyPrice - 1 * (commission.includePrice ? newCommission.price : 0);
      }
    }

    // move commission to below bill item
    const lastItemPosition = state.bill.billItems.indexOf(lastItem);
    state.bill.billItems.splice(lastItemPosition + 1, 0, newCommission);
  },

  addCreditBackCommission: (state, getters) => (commission) => {
    const lastItem = getters.getLastNormalItem;
    const newCommission = Object.assign({}, commission);
    newCommission.price = newCommission.price;
    newCommission.qty = -1;
    newCommission.total = newCommission.commissionIncludePrice ? 0 : (newCommission.price * newCommission.qty);
    newCommission.parent = lastItem.id;

    delete newCommission.id;
    // move commission to below bill item
    const lastItemPosition = state.bill.billItems.indexOf(lastItem);
    state.bill.billItems.splice(lastItemPosition + 1, 0, newCommission);
  },

  removeBillItem: state => (billItem) => {
    const removeItemIndex = state.bill.billItems.findIndex(item => item === billItem);
    const indexRemove = [];
    indexRemove.push(removeItemIndex);
    if (state.bill.billItems[removeItemIndex + 1] && state.bill.billItems[removeItemIndex + 1].type == state.COMMISSION_ITEM) {
      indexRemove.push(removeItemIndex + 1);
    }
    state.bill.billItems = state.bill.billItems.filter((item, index) => !indexRemove.includes(index));
  },
  removeLastLine: state => () => {
    const lastItem = state.bill.billItems[state.bill.billItems.length - 1];
    if(!lastItem) return;
    if (lastItem.type == state.COMMISSION_ITEM) {
      state.bill.billItems.splice(state.bill.billItems.length - 1);
    }
    state.bill.billItems.splice(state.bill.billItems.length - 1);
  },

  getBuyXGetYItems: (state, getters) => (isAll = false) => {
    const items = {};
    const cb = ({ product, qty, type }, index, array) => {
      const isCommissionItem = getters.isCommissionItem({ type }, array[index + 1]);
      const promotion = getters.getPromotionByArticle({ id: product });
      if (isCommissionItem || !getters.isBuyXGetYPromotion(promotion)) return;

      if (items[product]) {
        items[product].totalQty += qty;
      } else {
        items[product] = {
          product,
          totalQty: qty,
          promotionBuyX: promotion.value,
          promotionGetY: promotion.subValue,
          buyX: 0,
          getY: 0,
        };
      }
    };

    state.previousOrder.forEach(cb);

    if (isAll) {
      state.bill.billItems.forEach(cb);
    }

    Object.values(items).forEach((item) => {
      const { promotionBuyX, promotionGetY, totalQty } = item;
      const block = promotionBuyX + promotionGetY;
      const multiple = Math.floor(totalQty / block);

      const buyInBlock = promotionBuyX * multiple;
      const getInBlock = promotionGetY * multiple;
      const remain = totalQty - (buyInBlock + getInBlock);
      const remainBuy = (remain > promotionBuyX) ? promotionBuyX : remain;
      const remainGet = (remain > remainBuy) ? (remain - remainBuy) : 0;

      item.buyX = buyInBlock + remainBuy;
      item.getY = getInBlock + remainGet;
    });

    return items;
  },

  getItemWithoutPromotion: (state, getters) => (item) => {
    const { product, qty } = item;
    const article = getters.getObject(product, 'articles');
    let originalPrice = getters.getArticleProperty(article, 'price');
    if(article.variablePrice && item.productPrice != originalPrice) {
        originalPrice = item.productPrice;
    }
    const total = originalPrice * qty;
    const updatedItem = {
      ...item,
      price: originalPrice,
      promotion: '',
      total: getters.calTotal(article, total),
    };

    return updatedItem;
  },

  getItemBuyXGetYPromotion: (state, getters) => (buyXGetYItems, item, promotion) => {
    const { product, qty } = item;
    const includedProduct = buyXGetYItems[product];
    const article = getters.getObject(product, 'articles');
    const originalPrice = getters.getArticleProperty(article, 'price');

    let newTotal = originalPrice * qty;
    let promotionName = '';

    if (includedProduct) {
      if (qty <= includedProduct.buyX) {
        includedProduct.buyX -= qty;
      } else {
        includedProduct.getY -= (qty - includedProduct.buyX);
        newTotal = originalPrice * includedProduct.buyX;
        promotionName = promotion.name;
        includedProduct.buyX = 0;
      }
    }

    const updatedItem = {
      ...item,
      price: originalPrice,
      promotion: promotionName,
      total: newTotal,
    };

    return updatedItem;
  },

  getItemNormalPromotion: (state, getters) => (item, promotion) => {
    const { product, qty } = item;
    const article = getters.getObject(product, 'articles');
    let originalPrice = getters.getArticleProperty(article, 'price');
    if(article.variablePrice && item.productPrice != originalPrice) {
        originalPrice = item.productPrice;
    }
    const actualPrice = getters.getPromotionPrice(promotion, originalPrice);
    const total = actualPrice * qty;
    const updatedItem = {
      ...item,
      price: actualPrice,
      promotion: promotion.name,
      total: getters.calTotal(article, total),
    };

    return updatedItem;
  },

  updatedBillItems: (state, getters) => {
    const updatedItems = [];
    const buyXGetYItems = getters.getBuyXGetYItems(false);
    const cb = (item, index, array) => {

      if(item.type == COMMISSION_ITEM
      ) {
        const parent = array[index - 1];
        if(parent && parent.promotion) {
          const parentPromotion = getters.getPromotionByName(parent.promotion);
          if(parentPromotion.promotionType == PROMOTION.FREE_ALL)
            item.total = 0;
            updatedItems.push(item);
        }
        return;
      }
      const promotion = getters.getPromotionByArticle({ id: item.product, orderTime: item.createdDate });

      const isCommissionItem = getters.isCommissionItem(item, array[index + 1]);
      if(
        (!promotion || promotion.promotionType !== PROMOTION.FREE_ALL)
        && isCommissionItem
      ) return;

      let updatedItem = null;
      if (!promotion) {
        updatedItem = getters.getItemWithoutPromotion(item);
      } else if (getters.isBuyXGetYPromotion(promotion)) {
        updatedItem = getters.getItemBuyXGetYPromotion(buyXGetYItems, item, promotion);
      } else {
        updatedItem = getters.getItemNormalPromotion(item, promotion);
      }
      updatedItem.margin = updatedItem.buyPrice === 0 ? 0 : parseFloat((updatedItem.total - (updatedItem.buyPrice * updatedItem.qty)).toFixed(2));
      if (updatedItem.id !== undefined) {
        updatedItems.push(updatedItem);
      }

      item.price = updatedItem.price;
      item.promotion = updatedItem.promotion;
      item.total = updatedItem.total;
      item.margin = updatedItem.margin;
    };


    state.previousOrder.forEach(cb);
    state.bill.billItems.forEach(cb);

    return updatedItems;
  },

  isCommissionItem: state => (item, nextItem) => {
    const { COMMISSION_ITEM } = state;
    return (
      item.type === COMMISSION_ITEM
      || (nextItem && nextItem.type === COMMISSION_ITEM)
    );
  },
};

// actions
const actions = {
  async postBill({
    state, dispatch
  }, billData) {
    const result = await BillService.post(billData);
    if (!result || !result.insert) return;
    state.billModal = 'new';
    const isBillSet = await dispatch('setBill', result.insert.concat(result.update));
    if(isBillSet) {
      const data = await BillService.getPrintProductGroupTicket(state.bill.id);
      if (data) {
        dispatch('print', data);
      }
    }
  },

  async closeBill({
    state, dispatch
  }, bill) {
    const result = await BillService.closeBill(bill);
    if (!result || !result.update) return;
    state.billModal = 'close';
    dispatch('setBill', result.update);
  },

  async voidBill({ state, dispatch }, { id, statusNote }) {
    const result = await BillService.voidBill(id, statusNote);
    if (!result || !result.update) return;
    state.billModal = 'voided';
    dispatch('setBill', result.update);
  },

  async setBill({ state, getters, commit, dispatch }, payload) {
    if(!payload) {
      dispatch('resetBill');
      return false;
    }
    let bill = payload;
    if(Array.isArray(payload)) {
      bill = payload.find(object => object.class === 'Bill');
      if(!bill || !state.bills[bill.id]) {
        dispatch('resetBill');
        return false;
      }
      bill = Object.assign({}, state.bills[bill.id]);
    }
    // get bill data
    if (!bill.payDetails) {
      const result = await BillService.getBill(bill.id);
      if (result) {
        state.bills[bill.id] = Object.assign({}, result);
        bill = Object.assign({}, result);
      }
    }
    state.previousOrder = bill.billItems ? [...bill.billItems] : [];
    bill.billItems = [];
    state.bill = bill;
    if(Array.isArray(payload)) {
      commit(TOGGLE_BILL_MODAL_VISIBLE, true);
    }
    return true;
  },

  async setSplittedBill({ state, getters, commit, dispatch }, payload) {
    if(!payload) {
      return dispatch('resetBill');
    }
    const splittedBills = payload.filter(object => object.class === 'Bill');
    if(splittedBills[0].number < splittedBills[1].number) {
      state.secondBill = state.bills[splittedBills[1].id];
      state.firstBill = state.bills[splittedBills[0].id];
    } else {
      state.secondBill = state.bills[splittedBills[0].id];
      state.firstBill = state.bills[splittedBills[1].id];
    }
    dispatch('setBill', Object.assign({}, state.firstBill));
    commit(TOGGLE_BILL_MODAL_VISIBLE, true);
  },

  resetBill({ state }) {
    state.bill = Object.assign({}, state.emptyBill);
    state.bill.billItems = [];
    state.previousOrder = [];
    state.billPayDetails = [];
    state.payCash = '';
    state.billModal = '';
    return state.bill;
  },
  clearOrder({state, dispatch}) {
    if (state.bill.billItems.length === 0) {
      dispatch('resetBill');
    } else {
      state.bill.billItems = [];
    }
  },
  resetCurrentQuantityIncrease({state}) {
    if(state.currentQuantityIncrease !== 1) {
      state.currentQuantityIncrease = 1
    }
  }
};

export default {
  state: localState,
  getters: localGetters,
  actions,
};
